import { render, staticRenderFns } from "./article.vue?vue&type=template&id=6a7aaab7&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"
import style0 from "./article.vue?vue&type=style&index=0&id=6a7aaab7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7aaab7",
  null
  
)

export default component.exports